var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-active-sign-detail',{staticClass:"pt-active-sign-detail__page",attrs:{"id":_vm.id,"signId":_vm.signId}})}
var staticRenderFns = []

export { render, staticRenderFns }